import { render, staticRenderFns } from "./CatalogosGeneral.vue?vue&type=template&id=3fe0b784&"
import script from "./CatalogosGeneral.vue?vue&type=script&lang=js&"
export * from "./CatalogosGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports